// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__anJII","buttons":"SendReceipts_buttons__1cag0","email":"SendReceipts_email__2qNgW","bookApptTitle":"SendReceipts_bookApptTitle__t6FdB"};